import CommonButton from "../../../Components/CommonButton";
import { useSnackbar } from "../../../Context/SnackbarContext";
import { colors } from "../../../Utils/Index";
import { Modal } from "antd";
import React, { useEffect, useState } from "react";

const FoodGroupOptionModal = ({
  open,
  setOpen,
  detail,
  setOrdereditems,
  orderedItems,
}) => {
  const showSnackbar = useSnackbar();
  const [selectedOption, setSelectedOption] = useState([]);

  useEffect(() => {
    setSelectedOption(
      detail?.variantList?.map((i) => {
        return {
          foodId: detail?.id,
          foodName: detail?.name,
          foodVariant: i?.variantName,
          quantity: 0,
          totalTax:
            detail.cgst_tax +
            detail.gstTax +
            detail.other_tax +
            detail.sgst_tax,
          price: i?.variantPrice,
          basePrice: detail?.price,
          description: detail?.description,
        };
      })
    );
    //eslint-disable-next-line
  }, []);
  const handleManageQuantity = (type, index) => {
    let temp = [...selectedOption];
    if (type === "add") {
      temp[index] = { ...temp[index], quantity: temp[index].quantity + 1 };
    } else if (type === "subtract") {
      if (temp[index].quantity > 0) {
        temp[index] = { ...temp[index], quantity: temp[index].quantity - 1 };
      }
    }
    setSelectedOption(temp);
  };

  const handleAddFoodToCart = () => {
    if (selectedOption?.some((i) => i.quantity > 0)) {
      let temp = [
        ...orderedItems,
        ...selectedOption?.filter((i) => i.quantity !== 0),
      ];
      const combinedItems = temp.reduce((acc, item) => {
        const existingItem = acc.find(
          (obj) =>
            obj.foodId === item.foodId && obj.foodVariant === item.foodVariant
        );
        if (existingItem) {
          existingItem.quantity += item.quantity;
        } else {
          acc.push({ ...item });
        }
        return acc;
      }, []);
      setOpen(false)
      setOrdereditems(combinedItems);
      showSnackbar("Added to cart", "success");
    } else {
      showSnackbar("Select atleast one varient", "error");
    }
  };

  return (
    <Modal
      className="confirm-modal"
      closable={false}
      footer={null}
      open={open}
      onCancel={() => setOpen(false)}
      onClose={() => setOpen(false)}
    >
      <div className="text-dynmaicBg2 font-inter">
        <p className="text-lg text-dynmaicBg2">
          {selectedOption?.[0]?.description || "Select an option"}
        </p>

        <div className="w-1/4 h-1 mt-1 bg-dynmaicBg2"></div>
      </div>

      <div className="mt-4 max-h-[250px] overflow-y-scroll shadow-sm shadow-darkbg rounded-lg p-2">
        {selectedOption?.map((i, index) => {
          return (
            <div
              key={index}
              className="flex justify-between font-inter mb-8 capitalize items-center gap-4"
            >
              <p
                style={{ wordBreak: "break-all" }}
                className="text-dynmaicBg2 text-md font-bold break-words"
              >
                {i.foodVariant}
              </p>

              <div className="flex justify-center text-dynmaicBg2 font-bold items-center gap-2">
                <p>₹ {i.basePrice}</p>

                <p
                  onClick={() => handleManageQuantity("subtract", index)}
                  className="bg-red-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold"
                >
                  -
                </p>

                <p className="text-dynmaicBg2">{i.quantity}</p>

                <p
                  onClick={() => handleManageQuantity("add", index)}
                  className="bg-green-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold"
                >
                  +
                </p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex justify-end items-center mt-4  ">
        <CommonButton
          onClick={handleAddFoodToCart}
          text={"Add"}
          color={colors.green}
        />
      </div>
    </Modal>
  );
};

export default FoodGroupOptionModal;
